const oldaTopics: string[] = [
    'Agreements',
    'Asset Management',
    'Banking',
    'Cancer Research',
    'Cash Flow',
    'Consolidated Statements',
    'Cost Management',
    'Currency Exchange',
    'Digital Media',
    'Dividends',
    'Earnings Guidance',
    'EBITDA',
    'Economic Impact',
    'Energy Utilities',
    'Financial Liabilities',
    'Financial Measures',
    'Financial Outlook',
    'Financial Statements',
    'Fiscal Year',
    'Government Contracts',
    'Healthcare Services',
    'Hospitality',
    'Insurance',
    'Interest Rates',
    'Investor Relations',
    'Market Demand',
    'Market Growth',
    'Monthly Results',
    'Net Income',
    'Net Loss',
    'Non-GAAP',
    'Oil and Gas',
    'Operating Margin',
    'Percentage Change',
    'Press Release',
    'Prior Year Comparison',
    'Production Costs',
    'Quarterly Income',
    'Quarterly Report',
    'Regulatory Compliance',
    'Retail Sales',
    'Revenue Growth',
    'Sales Growth',
    'Second Quarter',
    'Shareholder Information',
    'Special Items',
    'Supply Chain',
    'Tax Adjustments',
    'Technology Solutions',
    'Year-End Results'
];

export default oldaTopics;
